import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconsModule } from 'src/app/icons/icons.module';
import { MenuComponent } from 'src/app/ui/menu/menu.component';
import { GlobalSearchComponent } from '../global-side-nav/global-search/global-search.component';
import { CoreModule } from '@core/core.module';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { ComponentsModule } from '@components/components.module';
import { GlobalAppointmentsComponent } from '../global-side-nav/appointments/appointments.component';
import { SupportComponent } from '../global-side-nav/support/support.component';
import { ContentHeaderComponent } from 'src/app/ui/content-header/content-header.component';
import { ButtonComponent } from 'src/app/ui/button/button.component';

@NgModule({
	declarations: [
		GlobalSearchComponent,
		GlobalAppointmentsComponent,
		SupportComponent,
	],
	imports: [
		CoreModule,
		CommonModule,
		IconsModule,
		MenuComponent,
		ContentHeaderComponent,
		ButtonComponent,
		FormsModule,
		AtomicModule,
		ComponentsModule,
	],
	exports: [
		CommonModule,
		IconsModule,
		MenuComponent,
		FormsModule,
		GlobalSearchComponent,
		GlobalAppointmentsComponent,
		ContentHeaderComponent,
		CoreModule,
		AtomicModule,
		ComponentsModule,
		ButtonComponent,
		SupportComponent,
	],
})
export class NavbarModule {}
